import Loadable from 'react-loadable';

const DirectoryPage = Loadable<any, any>({
  loader: () => import(/* webpackChunkName: "DirectoryPage" */ './DirectoryPage'),
  loading: () => null,
});

export default DirectoryPage;
